import React, { Component } from "react";
import data from "../../style/images/data.png";
import speak from "../../style/images/speak.png";
import "./footer.css";
export default class Footer extends Component {
  render() {
    return (
      <div className="Footer">
        <br />
        <footer>
          <div className="container-fluid">
            <div className="total">
              <div className="row">
                <div className="col-sm-3" />
                <div className="col-sm-8" style={{ textAlign: "left" }}>
                  <span>27,453 </span> total tournaments played
                </div>
              </div>
            </div>
            <div className="award">
              <div className="row">
                <div className="col-sm-3" />
                <div className="col-sm-8" style={{ textAlign: "left" }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <img src={data} className="wow bounce" />
                  <span>£ 7.890, 00</span>awarded
                </div>
              </div>
            </div>
            <div className="advertise">
              <div className="row">
                <div className="col-md-3" />
                <div className="col-md-5" style={{ textAlign: "left" }}>
                  <span>advertise with us!</span>
                  <br />
                  <div className="shake">
                    all our giveaways are funded by advertisment{" "}
                  </div>
                </div>
                <div className="col-md-2" style={{ textAlign: "left" }}>
                  {" "}
                  <img
                    style={{ textAlign: "left" }}
                    src={speak}
                    className="wow shake"
                  />
                </div>
              </div>
            </div>
          </div>
        </footer>

        <div className="footbar">
          <div className="container">
            <div className="d-flex">
              <div>
                <div className="row">
                  <div className="col-xs-4">
                    {" "}
                    <h1 style={{ color: "white" , textAlign: "left"  }}>© 2019, Ad Thy Way Inc.</h1>
                  </div>
                  <div className="col-xs-3" />
                  <div className="col-xs-3">
                    {" "}
                    <a href="#">Terms Of Service</a>
                  </div>
                  <div className="col-xs-1">
                    {" "}
                    <a href="#">Privacy Policy</a>
                  </div>
                  <div className="col-xs-1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
